<div class="row">
  <div class="col-md-10 dialog-head">
    Account Access
  </div>
  <div class="col-md-2 text-right">
    <button mat-button [mat-dialog-close]="false" class="close_icon"><img
      src="../../../assets/fwdpayarcicons/close.svg"></button>
  </div>
</div>
<hr>
<div class="dialogContainer">
  <ng-container *ngIf="topErrorMessage">
    <!--<div class="row" *ngFor="let obj of keys ">-->
    <!--<p class="col-md-12 error" id="err" >{{topErrorMessage[obj]}}</p>-->
    <!--</div>-->
    <div class="row err" *ngFor="let obj of keys1 ">
      <div class="col-md-12 mb-1" *ngFor="let value of obj ">
        <p class="col-md-12 error" id="err">{{value}}</p>
      </div>
    </div>
  </ng-container>
  <div class="row err" *ngIf="!topErrorMessage">
    <p class="col-md-12 error" id="err1">{{errMsg}}</p>
  </div>
  <div class="row">
    <label  class="col-3 roles">Accounts:</label>
    <span class="error_sign" id="roles_ids1">!</span>
    <div class="col-9 rolelist dropdown" (mouseleave)="show = false">
      <!--<app-multi-select id="roles_ids" class="full-width" [List]="accountlist.data"
                        [preSelectedList]="data.account_access" (listEmitter)="selectedRole($event)"
                        [displayKey]="'account_name'"
                        [valKey]="'id'" style=" width: 126% !important;">
      </app-multi-select>-->
      <input type="text" class="form-control"  (click)="show = !show" (input)="show = true" [(ngModel)]="searchText" >
      <ul class="dropdown-menu position-relative full-width" [class.show]="show" >
        <li class="dropdown-item"><input type="checkbox" id="all" #allInp (change)="selectAll(allInp.checked)" ><label class="form-check-label ml-2" for="all">All</label></li>
        <li class="dropdown-item" *ngFor="let account of selectList| search:'account_name': searchText"><input type="checkbox" [id]="account.id" [(ngModel)]="account.selected"  ><label class="form-check-label ml-2" [for]="account.id">{{account.account_name}}</label></li>
      </ul>
    </div>
  </div>
</div>
<div class="row d_footer">

  <div class="col-md-8 pt-2 void_btn">
    <app-loading-button (buttonClick)="setRoles()" [buttonText]="'Save'"
                        [disable]="!isSelected()" [buttonWidth]="'25%'" [loadFlag]="loadFlag">
    </app-loading-button>
    <button mat-button [mat-dialog-close]="false" (click)="closeDialog()" class="button upadte_cancel">Cancel</button>
  </div>
</div>
<!--<div class="row no-margin button_row">-->
<!--  <div class="col-3">-->
<!--  </div>-->
<!--  <div class="full-width button_col col-9" id="butn">-->
<!--    <app-loading-button (buttonClick)="setRoles()" [buttonText]="'Save'"-->
<!--                        [disable]="selectedRoleList.length <= 0" [buttonWidth]="'25%'" [loadFlag]="loadFlag">-->
<!--    </app-loading-button>-->
<!--   </div>-->

<!--</div>-->
